// New index file in src folder
module.exports = require("./src/index.js");

// OLD exports: TODO: all files below needs to be refactored and moved to src folder and included in new index file
module.exports.StateMachine             = require("./stateMachine.js");
module.exports.GuiEvents                = require("./event.js").GuiEvents;
module.exports.GuiEvent                 = require("./event.js").GuiEvent;
module.exports.Recorder                 = require("./event.js").Recorder;

module.exports.AbstractInteractionModel = require("./abstractInteractionModel.js");
module.exports.Controller               = require("./controller.js");

module.exports.DataManagerClientFactory = require("./dataManagerClientFactory");
module.exports.ContentServerClient      = require("./contentServerClient.js");
module.exports.DocumentLoaderFactory    = require("./documentLoaderFactory.js");
module.exports.AssetLoaderFactory       = require("./assetLoaderFactory.js");
module.exports.ContentServerAssetLoader = require("./contentServerAssetLoader.js");
module.exports.DummyAssetLoader         = require("./dummyAssetLoader.js");
module.exports.AppController            = require("./appController.js");
module.exports.AppWithoutDocumentController = require("./appWithoutDocumentController.js");
module.exports.DocumentLoaderFactory    = require("./documentLoaderFactory.js");

module.exports.AssetData = require("./assetData.js");

module.exports.HeavyHandler             = require("./heavyHandler.js");

module.exports.KeyCode                  = require("./keycode.js").KeyCode;
module.exports.NameManager              = require("./nameManager.js").NameManager;

module.exports.Model                    = require("./model.js");

module.exports.UserController           = require("./userController.js");


module.exports.showUI               = require("./showUI.js");

// candidates for removal:
module.exports.logError                 = require("./error.js");

module.exports.SpatialIndex             = require("./spatialIndex.js");

module.exports.ContentServerHandler          = require("./contentServerHandler.js");



